import React from "react";
import styled from "styled-components";

//components
import Container from "../components/container";
import Map from "../components/Map";

//icons
import phone from "../images/phone.svg";
import marker from "../images/marker.svg";
import SEO from "../components/SEO";
// import mail from '../images/envelope.svg'

const StyledContact = styled.div`
    ul {
        list-style-type: none;
    }
    #contact-info {
        li {
            margin-bottom: 10px;
        }
        img {
            width: 16px;
            margin-right: 10px;
        }
    }
`;

const contact = ({ location }) => {
    return (
        <>
            <SEO
                title="Contacteer ons"
                description="Je kan ons steeds telefonisch bereiken (ook in het weekend) om een afspraak te maken of te wijzigen."
                path={location.pathname}
            />
            <Container>
                <StyledContact>
                    <h1>Contacteer ons</h1>
                    <p>Om een afspraak te maken of te wijzigen, kan u ons telefonisch contacteren (ook in het weekend).</p>
                    <ul id="contact-info">
                        <li>
                            <img src={phone} alt="telefoon" />
                            <a href="tel:+32 3 449 17 26">03 449 17 26</a>
                        </li>
                        <li>
                            <img src={marker} alt="marker" />
                            Antwerpsestraat 72, 2640 Mortsel
                        </li>
                        {/* <li><img src={mail} alt="envelop"/><a href="#">info@yoursite.com</a></li> */}
                    </ul>
                    <h1>Openingsuren</h1>
                    <p>
                        Maandag t.e.m. vrijdag van 9.00 tot 18.00 uur
                        <br />
                        Dinsdag en woensdag met avondservice
                    </p>
                    <h2>Steeds op afspraak</h2>
                    <h1>Parking</h1>
                    <p>Er is een grote parking om de hoek (Krijgsbaan) waar je kan parkeren tegen 30 cent / uur</p>
                </StyledContact>
            </Container>
            <Map />
        </>
    );
};

export default contact;
